import CreateItemButton from "components/buttons/create";
import List from "components/list";
import HeaderPortal from "components/portal/header-portal";
import { PermissionGate } from "permissions";
import { getUserFields } from "components/user/config";
import { RenderProfile } from "components/render-profile";
import { useParams } from "react-router-dom";
import OpeningApplicantsFilters from "./filters";

export default function OpeningApplicants() {

    const { openingId } = useParams();

    const fields = [
        "id",
        getUserFields("employee"),
        "experience",
        "is_selected",
        "interviews"
    ];

    const columns = [
        {
            id: "employee",
            header: "Employee",
            accessorKey: "employee",
            cell: ({ getValue }) => <RenderProfile user={getValue()} />,
        },
        {
            id: "experience",
            header: "Experience (years)",
            accessorKey: "experience",
        },
        {
            id: "is_selected",
            header: "Selected",
            accessorKey: "is_selected",
            cell: ({ row }) => {
                const isSelected = row.original?.is_selected;
                if (isSelected === true) return "Yes";
                if (isSelected === false) return "No";
                return null;
            },
        },
        {
            id: "interviews",
            header: "Interviews",
            accessorKey: "interviews",
            cell: ({ row }) => {
                return row.original?.interviews?.length;
            },
        },
    ];

    const defaultFilters = {
        opening: {
            id: { _eq: openingId }
        },
    };

    const customSearch = (search) => ({
        _or: [
            { employee: { first_name: { _icontains: search } } },
            { employee: { last_name: { _icontains: search } } },
        ]
    });

    return (
        <div className="w-full">
            <HeaderPortal>
                <PermissionGate rule={"create:*"} collection="opening_applicants">
                    <CreateItemButton href={`/apps/openings/${openingId}/applicants/+`}>Applicant</CreateItemButton>
                </PermissionGate>
            </HeaderPortal>
            <div className="flex-1 h-full">
                <List
                    title="Applicants"
                    endPoint="opening_applicants"
                    storageKey={`applicants-list-${openingId}`}
                    perPage={10}
                    columns={columns}
                    filters={defaultFilters}
                    meta={{
                        fields,
                        customSearch,
                    }}
                    href={(item) => `/apps/openings/${openingId}/applicants/${item.id}`}
                    renderFilters={OpeningApplicantsFilters}
                />
            </div>
        </div>
    );
}
